var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCar = function SvgCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2CB989",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2625797,15.5 L10.2625797,15.5 C10.2625797,10.2532949 14.5158746,6 19.7625797,6 C25.0092849,6 29.2625797,10.2532949 29.2625797,15.5 Z M25.2625797,14.5 C25.2625797,11.4624339 22.8001459,9 19.7625797,9 C16.7250136,9 14.2625797,11.4624339 14.2625797,14.5 L25.2625797,14.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2625797,25 L14.2625797,25 C14.2625797,22.790861 12.4717187,21 10.2625797,21 C8.05344074,21 6.26257974,22.790861 6.26257974,25 L3,25 C1.8954305,25 1,24.1045695 1,23 C1,22.7936974 1.03191945,22.5886367 1.09462567,22.3920949 L2.17686546,19 C3.31710208,15.426124 6.63776259,13 10.3891262,13 L26.2625797,13 C30.6808577,13 34.2625797,16.581722 34.2625797,21 L34.2625797,25 L30.2625797,25 C30.2625797,22.790861 28.4717187,21 26.2625797,21 C24.0534407,21 22.2625797,22.790861 22.2625797,25 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.263,
    cy: 25,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.263,
    cy: 25,
    r: 3
  }))));
};
export default SvgCar;